import { render, staticRenderFns } from "./SlideShow.vue?vue&type=template&id=3270da8c&scoped=true&"
import script from "./SlideShow.vue?vue&type=script&lang=js&"
export * from "./SlideShow.vue?vue&type=script&lang=js&"
import style0 from "./SlideShow.vue?vue&type=style&index=0&id=3270da8c&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3270da8c",
  null
  
)

export default component.exports